<template>
  <div class="gradient-card" :class="classObj">
    <slot />
  </div>
</template>

<script>
export default {
  name: "GradientCard",
  props: {
    theme: {
      type: String,
      default: "main",
      validator: value => ["main", "second"].indexOf(value) !== -1
    }
  },
  computed: {
    classObj() {
      return {
        [`gradient-card_${this.theme}`]: this.theme
      };
    }
  }
};
</script>

<style lang="scss">
.gradient-card {
  position: relative;
  z-index: 1;
  overflow: hidden;
  background: colors(palette-2);

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
  }

  &_main {
    &:before {
      background: gradient("palette-5", #000, to top, 1, 0);
    }
  }

  &_second {
    &:before {
      background: gradient(palette-2, palette-5);
    }
  }
}
</style>
